import { useEffect, useMemo, useState } from 'react';
import { createContainer } from "unstated-next";
import { Receivable, ReceivableId } from '../types/taxLegalTypes';


// case DRAFT = 1;
// case OFFERED = 2;
// case ACCEPTED = 3;
// case INVOICE_SENT = 4;
// case PAID = 5;
export const DRAFT_ID = 1,
  OFFERED_ID = 2,
  ACCEPTED_ID = 3,
  INVOICE_SENT_ID = 4,
  PAID_ID = 5;

const useTaxLegalReceivablesStore = (initialState?: Receivable[]) => {
  const [receivables, setReceivables] = useState<Receivable[]>([])

  useEffect(() => {
    if (initialState?.length) {
      setReceivables(initialState)
    }
  }, [initialState])

  const offers = useMemo(() => {
    const offerIds = [DRAFT_ID, OFFERED_ID, ACCEPTED_ID]
    return receivables.filter(item => item.status && offerIds.includes(item.status?.id))
  }, [receivables])

  const acceptedOffers = useMemo(() => {
    return offers?.filter(offer => offer.status?.id === ACCEPTED_ID)
  }, [receivables])

  const invoices = useMemo(() => {
    const invoiceIds = [INVOICE_SENT_ID, PAID_ID]
    return receivables.filter(item => item.status && invoiceIds.includes(item.status?.id))
  }, [receivables])

  function addReceivable(receivable: Receivable) {
    setReceivables((prev) => [...prev, receivable])
  }
  function removeReceivable(receivableId: ReceivableId) {
    setReceivables((prev) => prev.filter(item => item.id !== receivableId))
  }
  function replaceReceivable(receivable: Receivable) {
    setReceivables((prev) => prev.map(item => {
      if (item.id !== receivable.id) return item
      return receivable;
    }))
  }


  return {
    receivables,
    invoices,
    offers,
    acceptedOffers,
    setReceivables,
    addReceivable,
    removeReceivable,
    replaceReceivable
  };
};

export const TaxLegalReceivablesStore = createContainer(useTaxLegalReceivablesStore);
